<template>
  <el-dialog
      :title="formatDate(currentDay.date, 'YYYY/MM/DD') + ' өдөр'"
      :visible.sync="isShow"
      :close-on-click-modal="isOpenDialog"
      @close="closeDialogDetail"
      :before-close="closeDialogDetail"
    >
      <el-table
        v-loading="orderDetailLoading"
        style="width: 100%; background-color: #fff"
        :data="orders"
      >
        <el-table-column type="expand" width="40">
          <div class="p20 pl60 background-light" slot-scope="prop">
            <el-row
              :gutter="20"
              v-for="(item, index) in prop.row.order_items"
              :key="index"
              class="pt10 pb10"
            >
              <el-col :span="12">
                {{ item.name }}
              </el-col>
              <el-col :span="2" class="text-right"> {{ item.count }}ш </el-col>
              <el-col :span="4" class="text-right">
                {{ formatPrice(item.price) }}₮
              </el-col>
            </el-row>
            <el-row :gutter="20" class="pt10 pb10">
              <el-col :offset="14" :span="4" class="text-right">
                <span>Нийт: {{ formatPrice(prop.row.total_sales) }}₮</span>
              </el-col>
            </el-row>
            <el-row>
              <el-tag type="danger" v-if="prop.row.is_canceled === true && prop.row.reason_type" style="margin-bottom: 10px">Цуцлалтын төрөл: {{prop.row.reason_type}}</el-tag>
            </el-row>
            <el-row>
              <el-tag type="danger" v-if="prop.row.is_canceled === true && prop.row.cancel_reason">Цуцалсан шалтгаан: {{prop.row.cancel_reason}}</el-tag>
            </el-row>
          </div>
        </el-table-column>
        <el-table-column prop="order_number" label="Дугаар"></el-table-column>
        <el-table-column prop="total_sales" label="Үнийн дүн">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.total_sales) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" prop="net_sales" label="Шимтгэл дүн">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.net_sales) }}₮
          </template>
        </el-table-column>
        <el-table-column width="100" prop="commission" label="Шимтгэл %"></el-table-column>
        <el-table-column label="Зөрүү">
          <template slot-scope="prop">
            <el-tag v-if="prop.row.isZoruu" size="small" type="danger"
              >Зөрүүтэй</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column  width="120" label="Тэмдэглэл">
          <template slot-scope="prop">
            <el-tag v-if="prop.row.isZoruu" type="danger">
              {{ prop.row.balance_note }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Төлөв" width="150">
          <template slot-scope="prop">
            <el-tag v-if="prop.row.is_canceled === true" type="danger">
              Цуцалсан
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Амжсан эсэх" width="150">
          <template slot-scope="prop">
            <el-tag v-if="prop.row.is_amjsan === true" type="success">
              Амжсан
            </el-tag>
            <el-tag v-if="prop.row.is_amjsan === false" type="danger">
              Амжаагүй
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="140" prop="confirmed_at" label="confirmed_at"></el-table-column>
        <el-table-column width="140" prop="kitchen_out" label="kitchen_out"></el-table-column>
        <el-table-column width="120" prop="menu_avg_time" label="menu_avg_time"></el-table-column>
        <el-table-column width="120" prop="delivery_charge" label="delivery_charge"></el-table-column>
        <el-table-column width="160">
          <template slot-scope="prop" v-if="prop.row.is_canceled === false">
            <el-button
              v-if="prop.row.isZoruu"
              size="mini"
              type="primary"
              @click="addDifference(prop.row)"
              >Зөрүүгүй болгох</el-button
            >
            <el-button
              v-else
              size="mini"
              type="primary"
              @click="addDifference(prop.row)"
              :disabled="[10, 20, 21].includes(current) ? false : true"
              >Зөрүү тэмдэглэх
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
</template>
<script>
import services from '@/helpers/partnerServices.js'
export default {
  name: 'SettlementDetailLog',
  props: {
    currentDay: Object,
    outletId: String,
    current: Number,
    isShow: Boolean,
    addDifference: Function,
    formatDate: Function,
    formatPrice: Function,
    close: Function,
    closeDialogDetail: Function
  },
  created () {
    this.getSettlementDayOrderData()
  },
  data () {
    return {
      isOpenDialog: false,
      orderDetailLoading: false,
      orders: []
    }
  },
  methods: {
    getSettlementDayOrderData () {
      this.orderDetailLoading = true
      const payload = {
        outlet_id: this.outletId,
        date: this.currentDay.date
      }
      services.getSettlementDayOrderData(payload).then((response) => {
        if (response.data.status === 'success') {
          this.orders = response.data.data
          this.orderDetailLoading = false
        } else {
          this.orders = []
          this.orderDetailLoading = false
        }
      })
    },
    mCloseFunction () {
      this.closeDialogDetail()
    }
  }
}
</script>
